import { Text } from "../Text/index.mjs";
import styled from "../../styled-components.mjs";
export var HeaderTitle = styled(Text).attrs({
  forwardedAs: 'h1',
  variant: 'bodyMediumBold'
}).withConfig({
  displayName: "HeaderTitle",
  componentId: "sc-1903a40-0"
})(["padding-block-end:0;"]);